import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  useForm,
  useFieldArray,
  FormProvider,
  Controller,
} from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { toast } from "core/Operations/toast";
import EmailAlertConfigForm from "Components/Form/EmailAlertConfigForm";
import {
  useGetEmailAlertConfigByIdQuery,
  useUpdateEmailAlertConfigMutation,
} from "AppQuries/setting/email-alert-config";
import { alertConfigValidation } from "core/Operations/ValidationSchema/settingsValidationSchema";
import { Save } from "react-feather";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { BackIcon } from "Components/UI/Icon/Icons";

const activeStatusOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

const EditEmailAlert = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();

  const {
    data: alertData,
    isLoading,
    isError: isGetAlertError,
    error: getAlertError,
  } = useGetEmailAlertConfigByIdQuery({
    code: code,
    companyCode: userData.companyCode,
  });

  const {
    mutate: updateEmailAlertConfig,
    isError,
    error,
  } = useUpdateEmailAlertConfigMutation();

  const methods = useForm({
    defaultValues: {
      alertConfigId: 0,
      companyCode: userData.companyCode,
      alertFrequency: "Daily",
      alertChannel: "Email",
      lastSentDate: "",
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
      emailAlertRecipients: [],
    },
    resolver: yupResolver(alertConfigValidation),
  });

  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    
    payload.modifyDate = getCurrentFormattedDate();
    payload.modifyUser = userData.userName;
    updateEmailAlertConfig(payload, {
      onSuccess: (data) => {
        if (data.response === true) {
          toast.success("Email Alert Config Updated Successfully.");

          setTimeout(() => {
            navigate(`${all_routes.setting}${all_routes.email_alert}`);
          }, 1000);
        } else {
          toast.error(data.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    console.log(alertData);
    if (Array.isArray(alertData)) {
      Object.keys(alertData[0]).forEach((key) => {
        setValue(key, alertData[0][key]);
      });
    }
  }, [alertData]);

  if (isLoading) return <LoadingSpinner />;
  if (isGetAlertError)
    return <Error404 isError={isGetAlertError} error={getAlertError} />;
  return (
    <div className="page-wrapper">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Edit Email Alert Config</h4>
                  {/* <h6></h6> */}
                </div>
              </div>
               <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Save </Tooltip>}
                >
                  <button
                    type="submit"
                    className="btn btn-added"
                    // disabled={!fields.length}
                  >
                    <Save className="me-2" />
                    Save
                  </button>
                </OverlayTrigger>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="back">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.setting}${all_routes.email_alert}`}
                    className="btn btn-secondary"
                  >
                    <BackIcon className="me-2" />
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
             
            </div>
            <div className="card border-0 mt-5">
              <div className="card-body">
                <EmailAlertConfigForm />
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default EditEmailAlert;
